import 'react-phone-number-input/style.css'
import { Dispatch, SetStateAction, useState } from 'react'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import styles from './style.module.scss';
import { errorMessages } from '../../configs';

type Tagged<A, T> = A & { __tag?: T };
type E164Number = Tagged<string, "E164Number">;

interface Props {
    label?: string;
    phoneNumber: string | undefined;
    disabled?: boolean;
    showErrorMessage?: boolean;
    setPhoneNumber: Dispatch<SetStateAction<string | undefined>>;
    isValid?: boolean;
    setIsValid?: Dispatch<SetStateAction<boolean>>;
};

function PhoneNumberInput(props: Props) {
    const [errorMessage, setErrorMessage] = useState('');

    const {
        label,
        disabled,
        phoneNumber,
        showErrorMessage,
        isValid,
        setIsValid,
        setPhoneNumber,
    } = props;

    const setValue = (value: E164Number) => {
        setPhoneNumber(value);
        let errorMessage = '';
        setErrorMessage('');

        if (!value) {
            setIsValid && setIsValid(true);
            return;
        }

        const phoneNumber = parsePhoneNumber(value);
        if (!phoneNumber?.isValid) {
            errorMessage = errorMessages.phone;
            setIsValid && setIsValid(false);
        } else {
            setIsValid && setIsValid(true);
        }

        setErrorMessage(errorMessage);
    };


    return (
        <div
            data-disabled={disabled}
            className={styles.wrapper}
            data-has-error={Boolean(errorMessage)}
        >
            {label && (<span className={styles.label}>{label}</span>)}
            <PhoneInput
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={setValue}
                className={styles.phone}
                limitMaxLength
                disabled={disabled}
            />
            {/* {showErrorMessage && errorMessage && (<span className={styles.error}>{errorMessage}</span>)} */}
        </div>
    )
};

export default PhoneNumberInput;
